import { Button } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';

interface Props {
    handleOpenDialog: () => void;
    handleFaqScroll: () => void;
}

const InactiveFoliosLink: React.FC<Props> = ({ handleOpenDialog, handleFaqScroll }) => {
    const history = useHistory();
    return (
        <div
            style={{
                marginBottom: '16px',
                padding: '16px',
                border: '1px solid black',
                borderRadius: '4px',
                display: 'flex',
                justifyContent: 'space-between',
                backgroundColor: 'white',
            }}
        >
            <a
                onClick={handleOpenDialog}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#0066cc',
                    textDecoration: 'none',
                }}
            >
                <span style={{ marginRight: '10px' }}>ℹ️</span>
                <span>How to locate your inactive folios?</span>
            </a>
            <Button
                onClick={handleFaqScroll}
                style={{ backgroundColor: '#7067df', color: 'white', padding: '5px 30px' }}
            >
                View FAQs
            </Button>
        </div>
    );
};

export default InactiveFoliosLink;
